import { render, staticRenderFns } from "./ticketDetailAffiliate.vue?vue&type=template&id=5b589bf8&lang=pug"
import script from "./ticketDetailAffiliate.vue?vue&type=script&lang=js"
export * from "./ticketDetailAffiliate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports